
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { SUPPORTED_LOCALES } from './constants/locales';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    supportedLngs: SUPPORTED_LOCALES,
    nonExplicitSupportedLngs: false,
    fallbackLng: 'en',
    backend: {
      loadPath: '/locales/{{lng}}.json'
    },
    keySeparator: '.',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['querystring', 'path', 'navigator'],
      caches: [],  // Disable caching to prevent persistence
      // ...other detection options as before
    }
  });

export default i18n;